export default __webpack_public_path__ + "static/justfrens-669dc4b306c1606b5b1e932fc4734f3e.jpg";